module.exports = __webpack_public_path__ + "img/header-engagementRingsWhitegold.24b1407.jpg";